import { IMultipleSelection, CLEAR_SELECTION, SET_SELECTED_CARDS, SET_SHOW_CHECKBOXES, TOGGLE_CARD } from '../types'

const initialState: IMultipleSelection = {
  selectedCards: [],
  showCheckboxes: false,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case SET_SELECTED_CARDS:
      return {
        ...state,
        selectedCards: action.payload
      }
    case CLEAR_SELECTION:
      return {
        ...state,
        selectedCards: []
      }
    case SET_SHOW_CHECKBOXES:
      return {
        ...state,
        showCheckboxes: action.payload
      }
    case TOGGLE_CARD:
      return {
        ...state,
        selectedCards: state.selectedCards?.includes(action.payload)
          ? state.selectedCards?.filter((id: number) => id !== action.payload)
          : [...(state.selectedCards || []), action.payload]
      }
    default:
      return state
  }
}
